import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

// 웹푸시 토큰 가져오기
export const getBrowserTokens = params => {
  return ApiService.query(`message/browserTokens?${stringify(params)}`);
};

// 웹푸시 토큰 저장
export const setBrowserTokens = params => {
  return ApiService.post(`message/browserTokens`, params);
};
